import { ChangeDetectionStrategy, Component, inject, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { ProductSearchViewModelGenericSearchResultViewModel } from '@models/api-search.models';
import { SearchService } from '@core/services/search.service';
import { ProductListSpot } from '@features/spots/umbraco-block-list-spot/block-list-spot.models';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AsyncPipe, NgIf } from '@angular/common';
import { ProductCardComponent } from '@features/product/product-card/product-card.component';
import { SpotHeadlineComponent } from '@features/spots/spot-headline/spot-headline.component';

@UntilDestroy()
@Component({
    selector: 'app-product-list-spot',
    imports: [ProductCardComponent, AsyncPipe, NgIf, SpotHeadlineComponent],
    templateUrl: './product-list-spot.component.html',
    styleUrl: './product-list-spot.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListSpotComponent implements OnInit {
    public static readonly ref: string = 'productListSpot';

    private readonly searchService: SearchService = inject(SearchService);
    public listOfProducts$: Observable<ProductSearchViewModelGenericSearchResultViewModel>;

    @Input() public data: ProductListSpot;

    ngOnInit() {
        this.listOfProducts$ = this.searchService
            .getProducts(...this.data.productSelectorList)
            .pipe(untilDestroyed(this));
    }
}
